import AvatarStatus from './AvatarStatus';

export default AvatarStatus;